import { render } from "./SpecialMeal.vue?vue&type=template&id=076ad50a&scoped=true"
import script from "./SpecialMeal.vue?vue&type=script&lang=js"
export * from "./SpecialMeal.vue?vue&type=script&lang=js"

import "./SpecialMeal.vue?vue&type=style&index=0&id=076ad50a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-076ad50a"

export default script